import { ClientsSearchApiInfo } from '@howdeniberia/client-search';
import { HowdenApiEnviroment, IHowdenApiInfo, IHowdenApiPaths } from '@howdeniberia/core-front';
import { API_PATH_APPS, FRONT_PATH_APPS } from 'src/app/core/constants';

export const ApiConfigurations: IHowdenApiInfo[] = [
  {
    name: API_PATH_APPS.API_PERSONAL_INSURANCE,
    paths: {
      local: 'https://localhost:5000',
      development: 'https://how-apipersonalinsurance.app-dev.howdeniberia.com',
      staging: 'https://how-apipersonalinsurance.app-staging.howdeniberia.com',
      production: 'https://how-apipersonalinsurance.app.howdeniberia.com'
    } as IHowdenApiPaths,
    useEnviroment: HowdenApiEnviroment.ENVIROMENT_CHOOSE,
    needsToken: true

  },
  {
    //TODO: pendiente determinar si creamos un nuevo objeto para definir urls de fronts, porque este objeto sería para urls de apis
    name: FRONT_PATH_APPS.FRONT_ELECTRONIC_SIGNATURE,
    paths: {
      local: 'https://local.app-dev.howdeniberia.com:4200',
      development: 'https://how-frontelectronicsignature.app-dev.howdeniberia.com',
      staging: 'https://how-frontelectronicsignature.app-staging.howdeniberia.com',
      production: 'https://how-frontelectronicsignature.app.howdeniberia.com'
    } as IHowdenApiPaths,
    useEnviroment: HowdenApiEnviroment.ENVIROMENT_CHOOSE,
    needsToken: true

  },

  ...ClientsSearchApiInfo
] as IHowdenApiInfo[];
